<script>
  import { fly } from "svelte/transition";
  import Button from "./Button.svelte";

  export let previous;
  export let showNewDistanceMessage = false;
</script>

<style>
  p {
    font-size: 1.25rem;
    margin-bottom: 3rem;
  }

  .buttons {
    margin: 2rem 2rem 0;
    display: grid;
    row-gap: 1rem;
    column-gap: 1rem;
    grid-template-rows: 1fr 1fr;
  }

  @media screen and (min-width: 640px) {
    .buttons {
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: initial;
    }

    .buttons *:nth-of-type(2) {
      grid-column: span 2;
    }
  }
</style>

<div in:fly={{ x: 200, duration: 200 }}>
  <p>
    <b>
      {#if showNewDistanceMessage}
        Din strecka är registrerad!
        <br />
        Nu är det bara att ut och gå. Uppmuntra fler att gå med genom att dela
        din insats på facebook. Glöm inte att lägga upp en bild från din
        promenad med #hållminhand
      {:else}
        Tack för att du gått och visat solidaritet med HBTQI-personer som inte
        kan hålla handen offentligt. Nu slår vi världsrekord!
      {/if}
    </b>
  </p>

  <div class="buttons">
    <div>
      <Button on:click={previous} outline={true} style="width: 100%;">
        ÄNDRA
      </Button>
    </div>
    <div>
      <Button
        href="#share"
        target="_self"
        style="width: 100%; display: inline-block;">
        DELA
      </Button>
    </div>
  </div>
</div>
